/* (ignored) */


//////////////////
// WEBPACK FOOTER
// buffer (ignored)
// module id = 923
// module chunks = 2